import { useEffect, useState } from 'react';

import { observer } from 'mobx-react';

import { useToasts } from 'react-toast-notifications';

import { Animated } from 'react-animated-css';

import { login } from '../../core/login.service';

import { addItem } from '../../core/storage';

import { VersionInfo } from '../VersionInfo';

import packageJson from '../../../package.json';

import logoAzul from '../../img/LogoAzul.png';

const MAX_PIN_LENGTH = 6;

export const LoginForm = observer(({ appStore }) => {
	const { addToast, removeAllToasts } = useToasts();
	const [pin, setPin] = useState('');
	const [storeId, setStoreId] = useState('')
	const [showVersionInfo, setShowVersionInfo] = useState(false);

	useEffect(() => {
		if (appStore.sessionExpiredMessage === true && !appStore.forceLogout) {
			const timeOutId = setTimeout(() => {
				addToast('Tu sesión ha expirado.', {
					appearance: 'warning',
					autoDismiss: true,
					placement: 'top-center'
				});
				appStore.sessionExpiredMessage = false;
				clearTimeout(timeOutId);
			}, 750);
		}
		// eslint-disable-next-line
	}, [appStore.sessionExpiredMessage]);

	const handleOnPinChange = (e) => {
		const value = e.target.value;
		if (/^[0-9\b]+$/.test(value) || value === '') {
			setPin(value);
		}
	};

	const handleOnStoreIdChange = (e) => {
		setStoreId(e.target.value);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		removeAllToasts();

		try {
			// Validar longitud del PIN
			if (pin.length < MAX_PIN_LENGTH || isNaN(Number(pin))) {
				addToast('Tu PIN debe ser un número válido con al menos 6 dígitos.', {
					appearance: 'warning',
					autoDismiss: true,
					placement: 'top-center',
				});
				return;
			}

			// Realiza la solicitud POST con las credenciales
			const data = await login({
				store_id: storeId,
				store_pin: pin,
			});

			if (data.response === true) {
				// Caso exitoso
				const { store } = data;

				appStore.sessionToken = 99;
				appStore.storeName = store.storeName;
				appStore.forceLogout = null;
				appStore.errorStarting = false;

				addItem('STORE_INFO', store);
				addItem('APP_TOKEN_SESSION', appStore.sessionToken);

			} else {
				// Manejo de mensajes de error específicos
				switch (data.details) {
					case 'request incomplete no body':
						addToast('La solicitud está incompleta', {
							appearance: 'error',
							autoDismiss: true,
							placement: 'top-center',
						});
						break;

					case 'request incomplete no values provided':
						addToast('Por favor, ingresa tu ID LOCACIÓN y/o PIN.', {
							appearance: 'error',
							autoDismiss: true,
							placement: 'top-center',
						});
						break;

					case 'error reading store on database':
						addToast('ID LOCACIÓN o PIN Incorrectos. Inténtalo nuevamente.', {
							appearance: 'error',
							autoDismiss: true,
							placement: 'top-center',
						});
						break;

					case 'error generating token':
						addToast('No se pudo generar el token. Inténtalo nuevamente.', {
							appearance: 'error',
							autoDismiss: true,
							placement: 'top-center',
						});
						break;

					default:
						addToast('ID LOCACIÓN o PIN Incorrectos. Inténtalo nuevamente.', {
							appearance: 'error',
							autoDismiss: true,
							placement: 'top-center',
						});
						break;
				}
			}
		} catch (err) {
			// Errores de red o excepciones inesperadas
			console.error('Error:', err.message);
			addToast('Hubo un problema con la conexión. Por favor, inténtalo de nuevo.', {
				appearance: 'warning',
				autoDismiss: true,
				placement: 'top-center',
			});
		}
	};

	return (
		<>
			{showVersionInfo && (
				<VersionInfo
					version={packageJson.version}
					onClose={() => setShowVersionInfo(false)}
				/>
			)}
			<Animated
				style={{ paddingTop: 20 }}
				animationIn='bounceInDown'
				animationInDuration={1400}
				isVisible
			>
				<div className='login-border-container'>
					<div className='login-page'>
						<div className='logo-azul'>
							<img src={logoAzul} alt='Logo' />
						</div>
						<div className='form'>
							<div className='login-form'>
								<input
									title='Por favor llena este campo.'
									name='id'
									value={storeId}
									type='text'
									placeholder='ID LOCACIÓN'
									onChange={handleOnStoreIdChange}
									required
								/>
								<input
									title='Por favor llena este campo.'
									name='pin'
									value={pin}
									type='text'
									placeholder='PIN'
									onChange={handleOnPinChange}
									maxLength={MAX_PIN_LENGTH}
									required
								/>
								<button onClick={handleSubmit} className='form-button'>Iniciar sesión</button>
							</div>
							<p
								className='version-data'
								onClick={() => setShowVersionInfo(true)}
							>
								Versión {packageJson.version}
							</p>
						</div>
					</div>
				</div>
			</Animated>
		</>
	);
});
